


















import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Discount, DiscountBannerSetting } from '../store/modules/discounts';
import BaseComponent from './Base';

const UiStore = namespace('ui');
const DiscountsStore = namespace('discounts');

@Component
export default class CoronaBanners extends BaseComponent {
    @UiStore.State('covidFormShowed') protected isShown: boolean;
    @UiStore.Mutation('covidShowForm') protected covidShowForm: (state?: boolean) => void;
    @DiscountsStore.State('discounts') protected readonly discounts: Discount[];
    protected panesState: Array<{ id: number, state: boolean, showIt: boolean }> = [];

  protected get filteredDiscount(): Discount[] {
      const discounts: Discount[] = [];
      const discount = this.discounts.find((d) => {
        return d.bannerSettings.enabled && d.name !== null && d.name.length > 0 && d.comment !== null && d.comment.length > 0;
      });
      if (discount) {
        discounts.push(discount);
      }
      // this.panesState.splice(0, this.panesState.length);
      // discounts.forEach((d) => this.panesState.push({ id: d.id, state: false }));

      return discounts;
    }

  protected getStyles(setting: DiscountBannerSetting): { [p: string]: any } {
    return {
      color: setting.fontColor,
      backgroundColor: setting.bgColor,
    };
  }

  protected hide() {
    this.covidShowForm(false);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CoronaBanners.vue